import React from 'react';

var Emblem = React.createClass({
    render: function(){
      return(
           	<div className="emblem"> 
           		<a href="javascript:void(0)">
           			<img src="images/source-code-emblem.png" alt="" title="" local/>
           		</a>
           	 </div>
        );
    }
}); 

export {Emblem};


/** WEBPACK FOOTER **
 ** ./html/components/Emblem.jsx
 **/